module.exports = __webpack_public_path__ + "static/media/Panturilha.7885a96c.png";